import { IUpdatesOptions } from '@store/redux/features/updates/updatesSlice';

export const countUpdatesFilter = (filtersData: IUpdatesOptions): number => {
  const manufactorNameCount = filtersData.manufactorNames.filter(
    item => item.active,
  ).length;
  const tagsCount = filtersData.tags.length;
  const startDateCount = filtersData.startDate ? 1 : 0;
  const endDateCount = filtersData.endDate ? 1 : 0;
  const daysCount =
    filtersData.checkThirtyDays ||
    filtersData.checkSixtyDays ||
    filtersData.checkNinetyDays
      ? 1
      : 0;
  return (
    manufactorNameCount + startDateCount + endDateCount + daysCount + tagsCount
  );
};
